<template>
    <div id="main">
        <!-- @71283 - Tela de criar/alterar um Cultivar -->
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="page page-container">
            <div class="novo-cultivar">
                <!-- TITULO + BREADCRUMB -->
                <h1 class="title">
                    {{ $t("cultivar") }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{
                                    isAgro ?
                                    $t("agro") :
                                    $t("vendas")
                            }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{
                                    isAgro ?
                                    $t("agro-cadastros") :
                                    $t("crm")
                            }}</a>
                        </li>
                        <li v-if="this.$route.query.tela">
                            <a class="a-inativo">
                                {{ $t("agro-niveltecnologico") }}
                            </a>
                        </li>
                        <li v-else>
                            <a @click="redirectToList()">
                                {{ $t("cultivar") }}
                            </a>
                        </li>
                        <li v-if="this.$route.query.tela">
                            <a @click="redirectToList()">
                                {{ $t("novo-nivel-tecnologico") }}
                            </a>
                        </li>
                        <li>
                            <a aria-current="page">{{
                                $route.params.id
                                    ? $route.params.descricao
                                    : $t("novo")
                            }}</a>
                        </li>
                    </ul>
                    <br />
                </nav>

                <!-- FORMULÁRIO -->
                <div class="columns">
                    <div class="column is-2">
                        <v-input
                            :id="'codigo'"
                            ref="idcultivarerpInput"
                            v-model="cultivar.idcultivarerp"
                            placeholder="placeholder-preencha"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                            :required="isUpdate"
                            :invalid="isUpdate && isNull(cultivar.idcultivarerp)"
                            :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                        />
                    </div>
                    <div class="column is-10 mb-4">
                        <v-input
                            ref="descricaoInput"
                            v-model="cultivar.descricao"
                            :id="'descricao'"
                            placeholder="descricao-do-cultivar-placeholder"
                            :maxlength="100"
                            title="descricao"
                            :invalid="isNull(cultivar.descricao)"
                            :required="true"
                            tooltipLabel="informacao-cultivar"
                            tooltipSize="is-small"
                            tooltipPosition="is-right"
                            uppercase
                            :disabled="isUpdate && !permissao.update"
                        />
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-4">
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <vss-select
                                    ref="culturaInput"
                                    class="no-clear"
                                    v-model="culturaSelected"
                                    title="cultura"
                                    placeholder="selecione"
                                    :required="true"
                                    :invalid="invalidCultura"
                                    :onBlurFunction="validateCultura"
                                    :msg="invalidCulturaMsg"
                                    :options="culturaSelect"
                                    tooltipLabel="informacao-culturas"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    @search="loadCultura"
                                    searchable
                                    :disabled="isUpdate && !permissao.update"
                                />
                            </div>
                            <div
                                class="
                                    control
                                    padding-label padding-label-custom
                                "
                            >
                                <b-button
                                    v-if="permissaoCultura.create"
                                    @click="showModalCadastrarCultura"
                                    icon-right="plus"
                                    v-tippy 
                                    :title="$t('adicionar')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BOTÕES -->
            <div class="form-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="redirectToList()"
                >
                    {{ $t("voltar") }}
                </button>
                <button
                    v-if="
                        ((isUpdate && permissao.update) ||
                            (!isUpdate && permissao.create)) &&
                        !cultivarIntegracao
                    "
                    class="save-btn"
                    type="button"
                    @click="save()"
                    :disabled="isSaving"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <!-- MODAL DE ASSOCIACAO -->
        <b-modal :active.sync="showModalCadastrar">
            <div class="bg">
                <CulturaModal
                    :permissaoVincular="!culturaIntegracao"
                    :idtTipoCultura="this.culturaSelected"
                    @fecharModal="fecharModal"
                    :abrev="abrev"
                    :isAgro="isAgro"
                    :isVenda="isVenda"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import CultivarService from "@/services/agro/CultivarService";
import CulturaService from "@/services/agro/CulturaService";
import CultivarValidation from "@/services/validations/agro/CultivarValidation";
import CulturaModal from "@/components/agro/cultivar/modal/CulturaModal.vue";
import Message from "@/models/Message";

export default {
    components: {
        CulturaService,
        CultivarService,
        CulturaModal,
    },
    data() {
        return {
            cultivarIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("CULTIVAR"),
            culturaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("TIPOCULTURA"),
            cultivarService: new CultivarService(this.$http, this.$router),
            culturaService: new CulturaService(this.$http, this.$router),
            validation: new CultivarValidation(this.$root.msgs),
            isSaving: false,
            msgs: [],
            cultivar: {
                id: null,
                idcultivarerp: null,
                descricao: null,
                idtipocultura: null,
            },
            situacoes: [
                { label: "todos", id: 2 },
                { label: "ativo", id: 1 },
                { label: "inativo", id: 0 },
            ],
            situacao: { label: "todos", id: 2 },
            title: "",
            permissao: {},
            isUpdate:
                this.$route.params.id != null && this.$route.params.id != "new",
            isLoading: false,
            culturaSelect: [],
            culturaSelected: null,
            invalidCultura: false,
            invalidCulturaMsg: "msg-campo-obrigatorio",
            showModalCadastrar: false,
            

            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
            originalIdErp: ''
        };
    },
    computed: {
        allowedCreateCultivar() {
            return !this.isUpdate && this.permissao.create;
        },
        allowedUpdateCultivar() {
            return this.isUpdate && this.permissao.update;
        },
    },
    created() {

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "agro-cultivar"
            );

            this.permissaoCultura = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "agro-cultura"
            );
        }else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "crm",
                "ven-cultivar"
            );

            this.permissaoCultura = this.hasPermissionAccess(
                "vendas",
                "crm",
                "ven-cultura"
            );
        }

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: `${this.abrev}-cultivar` },
            });

        !this.isUpdate &&
            !this.allowedCreateCultivar &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: `${this.abrev}-cultivar` },
            });

        if (this.$route.params.id) {
            this.carregarDados(this.$route.params.id);
        } else {
            this.loadCultura();
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.cultivarService.find(id, this.abrev)
                .then((value) => {
                    this.cultivar = value.content;
                    this.situacao = this.situacoes[this.cultivar.situacao];
                    this.originalIdErp = this.cultivar.idcultivarerp;
                    // carrega info do select
                    this.loadCultura();
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        validateCultura() {
            if (this.isNull(this.culturaSelected)) {
                this.invalidCultura = true;
                this.invalidCulturaMsg = "msg-campo-obrigatorio";
            } else {
                this.invalidCultura = false;
            }
        },
        loadCultura(search = '') {
            this.culturaService
                .findAllCombo(search)
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((tiposCultura) => {
                    this.culturaSelect = Object.assign(tiposCultura);
                    this.culturaSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (this.$route.query.idCultura) {
                        this.culturaSelected = this.culturaSelect.filter(
                            (f) => {
                                return f.id == this.$route.query.idCultura;
                            }
                        )[0];
                    } else {
                        if (
                            this.culturaSelect.length > 0 &&
                            this.cultivar.idtipocultura != null &&
                            this.cultivar.idtipocultura != 0
                        ) {
                            this.culturaSelected = this.culturaSelect.filter(
                                (f) => {
                                    return f.id == this.cultivar.idtipocultura;
                                }
                            )[0];
                        }
                    }
                });
        },
        redirectToList(time) {
            /* @71147 */
            let tempTela = null;
            if (this.$route.query.tela == "agro-niveltecnologico-new") {
                tempTela = this.$route.query.tela;
            } else if (this.$route.query.tela == "agro-niveltecnologico-edit") {
                tempTela = this.$route.query.tela;
            } else {
                tempTela = `${this.abrev}-cultivar`;
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query["id"] },
                });
            }, time * 1000 + 50);
        },
        redirectToPage() {
            this.$router.push({
                name: `${this.abrev}-cultivar-edit`,
                params: { id: this.cultivar.id, descricao: this.cultivar.descricao },
            });
        },
        save() {
            this.isLoading = true;

            if (
                this.validation.validate(
                    this.cultivar,
                    this.culturaSelected,
                    this.$refs
                )
            ) {
                if(this.isPrefixSovisInIdErpInvalid(this.cultivar.idcultivarerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
                    
                    this.isLoading = false;

                    return this.$root.showMessage('alert', message, true);
                }

                this.cultivar = this.mapTosave(this.cultivar);
                this.isSaving = true;

                let cultivarTemp = Object.assign({}, this.cultivar);
                cultivarTemp.idtipocultura = this.culturaSelected.id;

                this.cultivarService.save(cultivarTemp, this.abrev)
                    .then((body) => {
                        if (body.content) {
                            let msg = this.$t(
                                    this.cultivar.id
                                        ? "msg-edit-sucesso-n"
                                        : "msg-save-sucesso-n", 
                                    { n: this.$t("cultivar") }
                                );

                            this.$root.showMessage("success", msg, true, false);
                            this.cultivar = body.content;
                            this.originalIdErp = this.cultivar.idcultivarerp;
                            this.redirectToPage();
                            this.isUpdate = true;
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao"
                            );
                        }
                    })
                    .catch((e) => {
                        if (this.$te(e.body.message)) {
                            if (e.body.message == "msg-codigo-duplicado-n") {
                                this.msgs.push(
                                    new Message(
                                        "alert", 
                                        this.$t(e.body.message, { n: cultivarTemp.idcultivarerp }), 
                                        true, 
                                        false
                                    )
                                );
                            }else if (e.body.message) {
                                this.$root.showMessage("alert", e.body.message);
                            }
                        } else {
                            if (e.body.message != null) {
                                this.$root.showMessage("error", e.body.message);
                            } else {
                                this.$root.showMessage(
                                    "error",
                                    "msg-erro-load",
                                    true
                                );
                            }
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isLoading = false;
            }
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
            // Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, tendo assim que faze-las manualmente para poder apresentar os erros nos campos
            this.validateCultura();
        },
        showModalCadastrarCultura() {
            this.showModalCadastrar = !this.showModalCadastrar;
        },
        fecharModal() {
            this.showModalCadastrar = false;
            this.loadCultura();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
        margin-bottom: 40px;

        .novo-cultivar {
            position: relative;
            width: 100%;
            margin-bottom: 20px;
            height: 100%;
            padding-top: 0;

            > h1 {
                padding-top: 20px;
                margin-bottom: 40px;
            }
        }
    }
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}
</style>